<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="TOC">Contents</h1>
<p class="toc1" style="margin-top:20px;"><a href="#/4start#chap1">Romany Jake</a></p>
<p class="toc1"><a href="#/5chap2#chap2">The Verdict</a></p>
<p class="toc1"><span href="#/6chap3#chap3" title="Link target outside of Sample">Tamarisk</span></p>
<p class="toc1"><span href="#/7chap4#chap4" title="Link target outside of Sample">The Blind Girl</span></p>
<p class="toc1"><span href="#/8chap5#chap5" title="Link target outside of Sample">Riot</span></p>
<p class="toc1"><span href="#/9chap6#chap6" title="Link target outside of Sample">The Debt</span></p>
<p class="toc1"><span href="#/10chap7#chap7" title="Link target outside of Sample">After Waterloo</span></p>
<p class="toc1"><span href="#/11chap8#chap8" title="Link target outside of Sample">Blackmail</span></p>
<p class="toc1"><span href="#/12chap9#chap9" title="Link target outside of Sample">Suicide or Murder?</span></p>
<p class="toc1"><span href="#/13chap10#chap10" title="Link target outside of Sample">The Understanding</span></p>
<p class="toc1" style="margin-top:20px;"><span href="#/14preview#preview" title="Link target outside of Sample">Preview: <i>Midsummer’s Eve</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3TOC.vue?2a5cc61f